<template>
  <div v-if="show" class="scanner-wrapper">
    <div class="layout">
      <div class="container">
        <div id="canvas-container" class="canvas-container">
          <image-drawer
                  :image="image"
                  :points="points"
                  @input="$emit('input', $event)"
          >
            <template #crop>
              <slot name="crop"></slot>
            </template>
            <template #erase>
              <slot name="erase"></slot>
            </template>
            <template #drag>
              <slot name="drag"></slot>
            </template>
            <template #zoomIn>
              <slot name="zoomIn"></slot>
            </template>
            <template #zoomOut>
              <slot name="zoomOut"></slot>
            </template>
          </image-drawer>
          <receipt-scan-loader
                  v-if="isLoading"
                  :phrases="image ? phrases : cornerDetectionPhrases"
          ></receipt-scan-loader>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import ImageDrawer from './ImageDrawer.vue'
import ReceiptScanLoader from './ReceiptScanLoader.vue'

export default {
  name: 'receipt-scanner',
  components: {
    ReceiptScanLoader,
    ImageDrawer
  },
  props: {
    // main properties
    file: {
      type: [File,Blob],
      default: null
    },
    show:Boolean,
    // options
    phrases: {
      type: Array,
      required: true
    },
    cornerDetectionPhrases: {
      type: Array,
      required: true,
    },
    skipCornerDetection: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isLoading: false,
      image: null,
      points: [],
      axiosCancelSource: null
    }
  },

  watch: {
    isLoading (val) {
      console.log('isLoading', val)
    },
    file (file) {
      if (!file) {
        if (this.image) {
          this.image = null
          this.points = null
        }
        if (this.axiosCancelSource) {
          this.axiosCancelSource.cancel('cancel')
        }
        if (this.isLoading) {
          this.isLoading = false
        }
      }
      this.onFileChanged(file)
    }
  },

  methods: {
    onFileChanged () {
      if (!this.file) return

      this.isLoading = true

      const formData = new FormData()
      formData.append('receipt', this.file)

      this.axiosCancelSource = axios.CancelToken.source()

      if (this.skipCornerDetection) {
        this.isLoading = false

        const img = new Image()
        const reader = new FileReader()

        reader.onload = (event) => {
          img.onload = () => {
            this.points = []
            this.image = img
          }
          img.src = event.target.result
        }
        reader.readAsDataURL(this.file)

        return
      }
      axios.post(`https://receipt.justsnap.eu/getConvertedImageWithPoints`, formData, { cancelToken: this.axiosCancelSource.token })
        .then(resp => {
          this.isLoading = false
          this.axiosCancelSource = null
          if (resp.data.response === 'OK') {
            const img = new Image()
            img.addEventListener('load', () => {
              this.points = JSON.parse(resp.data.points)
              this.image = img
            });

            // Converting base64 to blob
            let ImageURL = resp.data.image
            var block = ImageURL.split(';');
            var contentType = block[0].split(':')[1];
            var realData = block[1].split(',')[1];
            var blob = this.b64toBlob(realData, contentType);
            var objectURL = URL.createObjectURL(blob);
            img.src = objectURL

          } else {
            // TODO: handle error
            // errorStore.handleError(resp.data.message)
          }
        })
        .catch(error => {
          // TODO: handle error
          // errorStore.handleError(error.message)
          this.isLoading = false;
          this.axiosCancelSource = null;
        })
    },
    b64toBlob (b64Data, contentType, sliceSize) {
      contentType = contentType || '';
      sliceSize = sliceSize || 512;

      var byteCharacters = atob(b64Data);
      var byteArrays = [];

      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);

        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
      }

      var blob = new Blob(byteArrays, { type: contentType });
      return blob;
    }
  }
}
</script>
